import React, { Component } from "react";
import { connect } from "react-redux";
import { unselectFlight, toggleModal, flightDirectionRedirect } from "../actions";
import { OPEN_MODAL } from "../shared/constants";
import {
	stretchTranslation,
	isValid,
	bestMaxMilhasPrice,
	defineFlightCabin
} from "../shared/utils";
import FlightStretch from "./FlightStretch";
import FlightResume from "./FlightResume";
import FlightsInterval from "./FlightsInterval";
import DispatchLuggage from "./DispatchLuggage";
import moment from "moment";
import { history } from "../react-app";
import {isMobile} from "./searchform/utils/common";

class FlightSelected extends Component {
	constructor() {
		super();
		this.state = {
			tripError: false
		};
	}

	unselectFlightButton() {
		if (this.props.enableSelectOtherFlight) {
			return (
				<div className="flight-stretch-details">
					<a
						title=""
						data-action={
							this.props.flightdata.direction === "outbound"
								? "choose-another-one-way-flight"
								: "choose-another-flight-back"
						}
						onClick={e => {
							e.preventDefault();
							this.props.unselectFlight(this.props.flightdata);
							history.push(window.location.pathname + "#changeFlight");
						}}
						className="btn btn-outline btn-xs"
					>
						<i className="icon-arrow-left" /> Escolher outro voo
					</a>
				</div>
			);
		}
	}

	renderFlightDetails() {
		if (this.props.flightdata) {
			if (
				this.props.flightdata.airline === "starAlliance" &&
				this.props.flightdata.pricing.mmBestPriceAt === "miles" &&
				(this.props.flightdata.pricing.miles.provider === "amigo" ||
					this.props.flightdata.pricing.miles.provider === "star_alliance") &&
				this.props.flightdata.updated !== true
			) {
				return (
					<div className="flight-stretch-group">
						<FlightStretch
							flightdata={this.props.flightdata}
							showFlightDetails={true}
							showStops={true}
							tripdata={{
								from: this.props.flightdata.from,
								to: this.props.flightdata.to,
								departureDate: this.props.flightdata.departureDate,
								arrivalDate: this.props.flightdata.arrivalDate,
								duration: this.props.flightdata.duration,
								flightNumber: this.props.flightdata.flightNumber
							}}
							shown={true}
							key={1}
						/>
						<i className="loader loader-fetching" />
					</div>
				);
			}

			if (
				this.props.flightdata.airline === "starAlliance" &&
				this.props.flightdata.pricing.mmBestPriceAt === "miles" &&
				(this.props.flightdata.pricing.miles.provider === "amigo" ||
					this.props.flightdata.pricing.miles.provider === "star_alliance") &&
				this.props.flightdata.updated === true &&
				this.props.flightdata.trips[0].carrier === undefined
			) {
				this.setState({ tripError: true });
				return null;
			}

			return this.props.flightdata.trips.map((trip, index, trips) => {
				let nextTrip = trips[index + 1] ? trips[index + 1] : "lastTrip";
				let changeAirport = nextTrip !== "lastTrip" && trip.to !== nextTrip.from;

				return (
					<div
						className="flight-stretch-group"
						key={index + 2 + this.props.flightdata.id + Date.now()}
					>
						<FlightStretch
							tripdata={trip}
							flightdata={this.props.flightdata}
							nexttripfrom={nextTrip.from}
							airportchange={changeAirport}
							shown={true}
							key={index + this.props.flightdata.id + Date.now()}
						/>

						{this.props.flightdata.stops !== "direct" && (
							<div className="flight-item-details">
								<ul className="list-inline">
									<li className="small">
										<strong>Classe deste trecho:</strong>{" "}
										{defineFlightCabin(
											trip,
											this.props.flightdata.airline,
											this.props.flightdata.pricing.mmBestPriceAt === "ota"
										)}
									</li>
									{trip.carrier &&
										trip.carrier !== "" && (
											<li className="small">
												<strong>Operado por:</strong> {trip.carrier}
											</li>
										)}
								</ul>
							</div>
						)}

						<FlightsInterval
							key={index + 1 + this.props.flightdata.id}
							flightdata={trip}
							airportchange={changeAirport}
							nexttripfrom={nextTrip.from}
							position={this.props.position}
						/>
					</div>
				);
			});
		}
	}

	showFlightDate() {
		if (this.props.flightdata.departureDate) {
			let date = new Date(this.props.flightdata.departureDate),
				utcDate = new Date(
					date.getUTCFullYear(),
					date.getUTCMonth(),
					date.getUTCDate(),
					date.getUTCHours(),
					date.getUTCMinutes(),
					date.getUTCSeconds()
				);
			return <span className="flight-schedule">{moment(utcDate).format("ddd, DD MMM")}</span>;
		}
	}

	luggageInformation() {
		if (this.props.flightdata.otaAvailableIn !== "airline") {
			const maxPricing = bestMaxMilhasPrice(this.props.flightdata.pricing);

			return isValid(maxPricing) &&
				isValid(maxPricing.luggage) &&
				isValid(maxPricing.luggage.carryOn) &&
				isValid(maxPricing.luggage.carryOn.weight) &&
				isValid(maxPricing.luggage.checked)
				? maxPricing.luggage
				: null;
		}

		return null;
	}

	render() {
		if (this.props.flightdata && !this.state.tripError) {
			return (
				<div className={`new-card selected-flight-box`}>
					<header className="new-card__header">
                        <h3 className={`new-card__title new-card__title_upper ${this.props.flightdata.direction}`}>
							<span className="flight__data flight__data_stretch"><i className={`icon-${this.props.flightdata.direction}`} /> {stretchTranslation[this.props.flightdata.direction]}</span>
							<span className="flight__data flight__data_trip">{this.props.flightdata.from} <i className="icon-arrow-right" /> {this.props.flightdata.to}, {this.showFlightDate()}</span>
						</h3>
					</header>
					<div className="new-card__content">
						<div className="flight-item">
                            {this.props.searchParams.cabin === "EX"
                            && this.props.searchStatus.isInternational
                            && this.props.flightdata.airline !== "gol"
                            && this.props.flightdata.pricing.mmBestPriceAt === "miles" && (
                                <div className="alert alert-info" role="alert">
                                    <div className="alert--icon">
                                        <i className="icon-exclamation" />
                                    </div>
                                    <div className="alert--message">
                                        <p>Existe a possibilidade de algum(s) do(s) trecho(s) ser(em) na <strong>classe ecônomica</strong>. Favor confirmar na Cia aérea.</p>
                                    </div>
                                </div>
                            )}
							<div className="flight-item-information luggage-info">
								{this.renderFlightDetails()}

								<DispatchLuggage
									key={Math.random()}
									lugagge={this.luggageInformation()}
									airline={this.props.flightdata.airline}
								/>

								{
									<FlightResume
										key={this.props.flightdata.id + this.props.flightdata.direction}
										flightdata={this.props.flightdata}
									/>
								}

								{this.unselectFlightButton()}
							</div>
						</div>
					</div>
				</div>
			);
		}

		if (this.state.tripError) {
			return (
				<div className="new-card not-found-error">
					<header className="new-card__header">
						<i className="icon-attention" />
						<h3 className="new-card__subtitle">Houve um problema no carregamento das informações sobre seu voo.</h3>
					</header>
					<div className="new-card__content">
						<p>Por favor, refaça sua busca em nosso site.</p>
						<button className="btn btn-default" onClick={() => location.reload()}>Refazer pesquisa</button>
					</div>
				</div>
			);
		}

		return null;
	}
}

const mapStateToProps = state => ({
	legacyId: state.searchStatus.legacyId,
	searchParams: state.searchParams.params,
	searchStatus: state.searchStatus,
	selectedFlights: state.selectedFlights
});

const mapDispatchToProps = dispatch => ({
	unselectFlight: flightdata => {
		dispatch(unselectFlight(flightdata));
		window.history.back();
	},
	openRedirectModal: () => dispatch(toggleModal(OPEN_MODAL)),
	flightDirectionRedirect: direction => dispatch(flightDirectionRedirect(direction))
});

export default connect(mapStateToProps, mapDispatchToProps)(FlightSelected);
